module.exports = __webpack_public_path__ + "img/GIB.59b57ed9.svg";